import { FormikHelpers } from "formik";
import { useContext } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { isTypeOfBillingSearchForm } from "src/components/Common/UI/SydFilter/SydFilterTypeChecker";
import BillingSearchForm from "./BillingSearchForm";

const emptyBillingSearchForm: IBillingSummarySearchForm = {
  year: "",
  monthName: "",
  providerID: ""
};

const SearchBilling = ()  => {
  const sydFilterCtx = useContext(SydFilterContext);

  const activeFilters = sydFilterCtx.activeFilters;
  const clearForm = sydFilterCtx.clearAllFilters;
  const saveFilters  = sydFilterCtx.saveFilters;
  const handleClose = sydFilterCtx.toggleFilterVisibility;

  const initialValues = isTypeOfBillingSearchForm(activeFilters) ? activeFilters as IBillingSummarySearchForm : emptyBillingSearchForm;

  const handleSubmit = async (values: IBillingSummarySearchForm, { setSubmitting }: FormikHelpers<IBillingSummarySearchForm>): Promise<void> => {
    saveFilters(values);
    setSubmitting(false);
    handleClose();
  }

  return (
    <BillingSearchForm initialValues={initialValues} onSubmit={handleSubmit} onClearForm={clearForm} />
  )
}


export default SearchBilling;